import $ from 'jquery';

export default function () {
  setTimeout(function(){
    $(".main-logo").animate({
      opacity: 1
    },1000,"swing",function(){
      $(".about-main picture").addClass("glitch");
      glitchChildAppend($(".about-main picture"))
    });
    $(".main-copy").animate({
      opacity: 1
    },1000,"swing",function(){
    });
    //ttl show
    scrollFader();
    $(window).on('scroll', scrollFader);
  },500)

}

const scrollFader = ()=>{
  $('.effect-fade').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > elemPos + 300 - windowHeight){
        if(!$(this).hasClass('effect-scroll')){
          var parent = $(this).parent();
          if($(this).hasClass("ondemand")){
            $(parent).addClass("glitch");
            glitchChildAppend($(parent))
          } else {
            setTimeout(function(){
              $(parent).addClass("glitch");
              glitchChildAppend($(parent))
            },1000);
          }
        }
        $(this).addClass('effect-scroll');
      }
  });
}

const glitchChildAppend = (parent) => {
  var rspan = $("<span></span>", { "class": "r glitch"});
  var gspan = $("<span></span>", { "class": "g glitch"});
  var bspan = $("<span></span>", { "class": "b glitch"});
  $(parent).append(rspan);
  $(parent).append(gspan);
  $(parent).append(bspan);
}
